import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Button } from "../generic/button/Button";
import { Icon } from "../generic/icon/Icon";
import { TextLoca } from "../generic/text/TextLoca";
export var TradeTabs = function (_a) {
    var activeTabIndex = _a.activeTabIndex, tabs = _a.tabs, onClick = _a.onClick;
    var tabItems = tabs.map(function (tab, index) {
        var locaKey = tab.locaKey, icon = tab.icon;
        var isTabActive = activeTabIndex === index;
        var tabStateClass = isTabActive ? " " + IdStyles.StateSelected : "";
        return (React.createElement(Button, { onClick: function () { return onClick(index); }, className: "tabs-row__item farm-management-detail__tabs-item " + IdStyles.TabItemBackground + " " + IdStyles.TextButtonHeading + tabStateClass, key: index },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconMedium }),
            React.createElement("div", { className: "tabs-row__item-text" },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: locaKey }))));
    });
    return React.createElement("div", { className: "tabs-row__items" }, tabItems);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/TradeTabs.tsx
// module id = 2652
// module chunks = 3